import { Reducer } from "redux";

import { ScorecardDetailsResponse } from "../models/api/Scorecard";
import { ScorecardDetailsDispatchTypes } from "../models/dispatchTypes/Scorecard";
import { GetScorecardDetailsActionDispatchTypes } from "../constants/Scorecard";

const initialState: ScorecardDetailsResponse = {
  loading: false,
  response: null,
  error: null,
};

const ScorecardDetailsReducer: Reducer<
  ScorecardDetailsResponse,
  ScorecardDetailsDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case GetScorecardDetailsActionDispatchTypes.GET_SCORECARD_DETAILS_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case GetScorecardDetailsActionDispatchTypes.GET_SCORECARD_DETAILS_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case GetScorecardDetailsActionDispatchTypes.GET_SCORECARD_DETAILS_ERROR: {
      return {
        ...state,
        error: action.error,
        response: null,
        loading: false,
      };
    }
    case GetScorecardDetailsActionDispatchTypes.GET_SCORECARD_DETAILS_RESET: {
      return initialState;
    }
  }
  return state;
};

export default ScorecardDetailsReducer;
